/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { get, CashRequestOptions, SerializeQueryParameters } from '@cash-web/shared-util-fetch'
import {GetCardThemeConfigsRequest} from '@cash-web/protos/squareup/cash/postcard/app/GetCardThemeConfigs.pb'
import {GetCardThemeConfigsResponse} from '@cash-web/protos/squareup/cash/postcard/app/GetCardThemeConfigs.pb'


export const getCardThemeConfigs = (params?: SerializeQueryParameters, options?: CashRequestOptions) => get<GetCardThemeConfigsResponse>("/cash-app/postcard/get-card-theme-configs", params, {...options, rejectOnError: true })